import React from 'react';
import css from '../styles/area-will.css';

const { Component } = React;

class AreaWill extends Component {
  render() {
    return (
      <div className="areas-area__wrapper areas-area__wrapper--will">
        <div className="areas-area__hero">
          <div className="areas-area__image">
          </div>
          <div className="areas-area__image-text" data-aos="zoom-in">
            <h3>Wills, Trusts &amp; Succession Planning</h3>
            <p>I can help with succession planning for you or your business, whether you have a complex estate or are just starting a family.  You can prevent unnecessary hardships for your loved ones with a practical plan tailored to your needs.</p>
          </div>
        </div>
        <div className="areas-area__content">

          <div className="areas-area__content-block" data-aos="zoom-in">
            <ul>
              <li><i className="fa fa-bookmark"></i>Last Will &amp; Testament</li>
              <li><i className="fa fa-bookmark"></i>Revocable Living Trust</li>
              <li><i className="fa fa-bookmark"></i>&quot;Pour-over&quot; Will</li>
              <li><i className="fa fa-bookmark"></i>&quot;Spendthrift&quot; Trust</li>
              <li><i className="fa fa-bookmark"></i>Irrevocable Trust</li>
              <li><i className="fa fa-bookmark"></i>Testamentary Trust</li>
              <li><i className="fa fa-bookmark"></i>Supplemental Needs Trust (Special Needs Trust)</li>
              <li><i className="fa fa-bookmark"></i>Durable Power of Attorney (Financial)</li>
              <li><i className="fa fa-bookmark"></i>Durable Power of Attorney (Health Care)</li>
              <li><i className="fa fa-bookmark"></i>Advance Directive for Health Care</li>
            </ul>
          </div>
          <div className="areas-area__content-block" data-aos="zoom-in">
            <h3>Trusts</h3>
            <p>Trusts are often useful to avoid probate and minimize taxes to you and your loved ones.  These can be simple or complex revocable or irrevocable trusts tailored to your specific concerns.  They can also be useful in making deferred gifts to charities and nonprofits as well as to protect assets from certain potential liabilities.</p>
          </div>
          <div className="areas-area__content-block" data-aos="zoom-in">
            <h3>Supplemental Needs Trust</h3>
            <p>A Supplemental (or Special) Needs Trust can help you care for a disabled loved one so as to minimize your financial obligations while maximizing your loved one’s eligibility for government assistance.  These can be especially useful when a loved one comes into a large sum of money through an injury settlement or inheritance. </p>
          </div>
          <div className="areas-area__content-block" data-aos="zoom-in">
            <h3>Avoidance of Probate</h3>
            <p>Many families do not need trusts or complex estate plans in order to avoid probate.  A very simple and practical estate plan can save you time and money and give you the satisfaction of knowing your loved ones are protected.  Some of the tools useful in this area are:</p>
            <ul>
              <li><i className="fa fa-bookmark"></i>Affidavit of Surviving Joint Tenant</li>
              <li><i className="fa fa-bookmark"></i>Affidavit of Heirship</li>
              <li><i className="fa fa-bookmark"></i>Small Estate Affidavit</li>
              <li><i className="fa fa-bookmark"></i>Unclaimed Property Affidavit</li>
              <li><i className="fa fa-bookmark"></i>Transfer on Death Deed</li>
              <li><i className="fa fa-bookmark"></i>Survivorship Accounts</li>
              <li><i className="fa fa-bookmark"></i>Pay on Death Accounts</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export { AreaWill };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Areas/components/area-will.js